<template>
	<div class="chat-cluster-info-box">
		<div class="chat-cluster-i-wrap">
			<div class="chat-cluster-i-basic">
				<div class="chat-cluster-ib-l">
					<div class="chat-cluster-ibl-basic">
						<div class="chat-cluster-ibl-avatar">
							<img :src="clusterInfo.cluster_photo | connectHost" alt="">
						</div>
						<div class="chat-cluster-ibl-title">
							<p>{{clusterInfo.cluster_name}}</p>
						</div>
					</div>
					<div class="chat-cluster-ibl-code">
						<img :src="clusterInfo.qrcode_img_url | connectHost" alt="" title="点击获取最新二维码" @click="updateQR">
					</div>
					<div class="chat-cluster-ibl-time">
						<p>二维码7天内有效，失效后请<span class="chat-cluster-ibl-time-reload" @click="updateQR">手动更新</span></p>
					</div>
				</div>
				<div class="chat-cluster-ib-r">
					<div class="chat-cluster-ibr-info">
						<div class="chat-cluster-ibr-item">
							<div class="chat-cluster-ibr-title">
								成员数量：
							</div>
							<div class="chat-cluster-ibr-text">
								{{clusterMembers.length}}个
							</div>
						</div>
						<div class="chat-cluster-ibr-item">
							<div class="chat-cluster-ibr-title">
								所属客服：
							</div>
							<div class="chat-cluster-ibr-text">
								{{cluster.custom_name}}<span style="color: #888888;">（{{customMember.is_owner === 1 ? '群主' : '非群主'}}）</span>
							</div>
						</div>
						<div class="chat-cluster-ibr-item">
							<div class="chat-cluster-ibr-title">
								群内昵称：
							</div>
							<div class="chat-cluster-ibr-text">
								<input type="text" name="alias" placeholder="我在本群的昵称" v-model="customMember.alias">
							</div>
						</div>
						<div class="chat-cluster-ibr-item">
							<div class="chat-cluster-ibr-title">
								群名称：
							</div>
							<div class="chat-cluster-ibr-text">
								<input type="text" name="cluster_name" placeholder="群昵称" v-model="clusterInfo.cluster_name" :disabled="customMember.is_owner != 1">
							</div>
						</div>
						<div class="chat-cluster-ibr-item">
							<div class="chat-cluster-ibr-title">
								群公告：
							</div>
							<div class="chat-cluster-ibr-text">
								<textarea placeholder="群公告" v-model="clusterInfo.cluster_notice" :disabled="customMember.is_owner != 1"></textarea>
							</div>
						</div>
					</div>
					<div class="chat-cluster-ibr-tools" v-if="clusterInfo.wechat_cluster_id != 0">
						<div class="chat-cluster-ibr-sender" @click="goChat">发消息</div>
						<div class="chat-cluster-ibr-remark" @click="updateClusterInfo('name')" v-if="customMember.is_owner === 1">改群名</div>
						<div class="chat-cluster-ibr-remark" @click="updateClusterInfo('notice')" v-if="customMember.is_owner === 1">改公告</div>
						<div class="chat-cluster-ibr-uf" @click="modifyAlias">改群内昵称</div>
						<div class="chat-cluster-ibr-uf" @click="pushGetRoomMembers" v-if="customMember.is_owner === 1">同步成员</div>
						<div class="chat-cluster-ibr-stop" @click="existRoom">删除并退出</div>
					</div>
					<div class="chat-cluster-ibr-tools" v-else>
						<!-- <div class="chat-cluster-ibr-sender" @click="reloadPushCreate">重新创建</div> -->
						<div class="chat-cluster-ibr-stop" @click="delCluster">删除</div>
					</div>
				</div>
			</div>
			<div class="chat-cluster-i-numbers">
				<div class="chat-cluster-in-list">
					<div class="chat-cluster-in-items-wrap">
						<div class="chat-cluster-in-items">
							<div class="chat-cluster-in-item" v-for="member in clusterMembers">
								<img :src="member.friends_photo | connectHost" alt="">
								<p>{{member.friends_wx_name}}</p>
							</div>
							<div class="chat-cluster-in-item">
								<div class="chat-cluster-ini-optmem" @click="addMember"></div>
							</div>
							<div class="chat-cluster-in-item" v-if="customMember.is_owner === 1">
								<div class="chat-cluster-ini-optmem chat-cluster-ini-optreduce" @click="reduceMember"></div>
							</div>
						</div>
					</div>
				</div>
			</div>
		</div>
	</div>
</template>

<script>
	import {webGetClusterAndMember,webSaveInfo,webDeleteCluster} from '../../../network/web/cluster.js'
	import {updateClusterName,deleteCluster,deleteClusterMemberByClusterId} from '../../../network/local/cluster.js'
	import {pushUpdateWechatQr,pushRemarkRoomName,pushSetRoomAnnouncement,pushGetRoomMembers,pushModifyNickName,pushExitChatRoom} from '../../../socket/socketEventSender.js'
	import {webSaveClusterMember} from '../../../network/web/cluster-member.js'
	import {updateRecentlyByFIdAndType,deleteRecentlyByFIdAndType} from '../../../network/local/recently.js'
	
	export default{
		name:'ChatclusterInfo',
		props:{
			cluster:{
				type: Object,
				default:function(){
					return {}
				}
			}
		},
		data(){
			return{
				clusterInfo:{},
				clusterMembers:[],
				customMember:{}
			}
		},
		methods:{
			init(){
				this.clusterInfo = {}
				this.clusterMembers = []
				this.customMember = {}
			},
			// 获取服务器的群详细信息和群成员信息
			getDetail(){
				this.init()
				if(this.cluster.id === undefined){
					return
				}
				webGetClusterAndMember(this.cluster.id,data=>{
					if(!data){
						return
					}
					// 获取群主信息
					let customMember = {}
					for (let i = 0; i < data.cluster_member.length; i++) {
						if(data.cluster_member[i].friends_open_id == this.cluster.custom_open_id){
							customMember = data.cluster_member[i]
							break
						}
					}
					this.clusterInfo = data.cluster
					this.clusterMembers = data.cluster_member
					this.customMember = customMember
				})
			},
			
			// 添加成员+号点击
			addMember(){
				let filterMembers = []
				for (let i = 0; i < this.clusterMembers.length; i++) {
					filterMembers.push(this.clusterMembers[i].friends_open_id)
				}
				this.$emit('add-member-call',{
					filterMembers:filterMembers,
					customId:this.cluster.custom_id !== undefined ? this.cluster.custom_id : 0
				})
			},
			
			//删除成员-号点击
			reduceMember(){
				let fanList = []
				for (let i = 0; i < this.clusterMembers.length; i++) {
					if(this.clusterMembers[i].is_owner == 1){
						continue
					}
					fanList.push({
						open_id:this.clusterMembers[i].friends_open_id,
						wx_name:this.clusterMembers[i].friends_wx_name,
					})
				}
				this.$emit('reduce-member-call',{
					fanList:fanList,
					customId:this.cluster.custom_id !== undefined ? this.cluster.custom_id : 0
				})
			},
			
			// 判断当前群是否为消息对应的群，重新拉取详细数据
			reloadById(clusterId){
				if(clusterId == this.cluster.id){
					this.getDetail()
				}
			},
			
			// 更新群二维码
			updateQR(){
				CHAT_LAYER.msg('二维码更新中，请稍后...',{icon:7})
				pushUpdateWechatQr(this.clusterInfo.id,this.customMember.friends_open_id)
			},
			
			// 修改群名，群公告
			updateClusterInfo(type){
				webSaveInfo(this.clusterInfo,data=>{
					CHAT_LAYER.msg('指令推送成功，请稍后...',{icon:7})
					if(data){
						// 推送更新群名的指令
						if(type === 'name'){
							updateClusterName(this.clusterInfo.id,this.clusterInfo.cluster_name,res=>{
								// nothing to do
							})
							updateRecentlyByFIdAndType(this.clusterInfo.id,2,this.clusterInfo,res=>{
								// nothing to do
							})
							pushRemarkRoomName(this.clusterInfo.id)
							// 自定义事件，仅仅是为了渲染页面更新
							let bean  = {
								type: 'AT_update_cluster_name',
								clusterId: this.clusterInfo.id,
								clusterName: this.clusterInfo.cluster_name
							}
							this.$store.commit('updateOtherEvent',bean)
						}
						// 推送更新群公告的指令
						else if(type === 'notice'){
							pushSetRoomAnnouncement(this.clusterInfo.id)
						}
					}
				})
			},
			
			// 同步群成员
			pushGetRoomMembers(){
				CHAT_LAYER.msg('群成员同步中，请稍后...',{icon:7})
				pushGetRoomMembers(this.clusterInfo.id)
			},
			
			// 修改我在群内名称
			modifyAlias(){
				CHAT_LAYER.msg('修改指令推送成功，请稍后...',{icon:7})
				webSaveClusterMember(this.customMember,res=>{
					if(res){
						pushModifyNickName(this.customMember.id,this.customMember.alias)
					}
				})
			},
			
			// 删除并退出-针对于群主操作
			existRoom(){
				let _this = this
				CHAT_LAYER.open({
				    title:'重要提示',
				    content:'此操作针对客服（<span style="color: #257d54;font-weight: 600">'+this.customMember.friends_wx_name+'</span>），会删除系统中的群信息，并退出该微信群。如想保留系统群信息，请选转让群，然后删除成员。<br/>' +
				        '<span style="color: red;font-weight: 600">确认要删除并退出该群吗？</span>',
				    btn: ['确认', '取消'],
				    yes: function(index, layero){
						CHAT_LAYER.close(index);
						pushExitChatRoom(_this.clusterInfo.id,_this.customMember.friends_open_id)
						CHAT_LAYER.msg('删除指令推送成功，请稍后...',{icon:7})
				    }
				}) ;
			},
			
			// 删除群，仅仅只是删除服务器数据，本地数据
			delCluster(){
				webDeleteCluster(this.clusterInfo.id,res=>{
					// 删除本地群信息
					deleteCluster(this.clusterInfo.id,res=>{
						// 什么都不做
					})
					// 删除本地群成员信息
					deleteClusterMemberByClusterId(this.clusterInfo.id,res=>{
						// 什么都不做
					})
					// 删除最近聊天表信息
					deleteRecentlyByFIdAndType(this.clusterInfo.id,2,res=>{
						// 什么都不做
					})
					let bean  = {
						type: 'C_ExitChatRoom',
						clusterId: this.clusterInfo.id
					}
					this.$store.commit('updateOtherEvent',bean)
				})
			},
			
			// 跳转聊天页面
			goChat(){
				let query = {
					c_id: this.cluster.custom_id !== undefined ? this.cluster.custom_id : 0,
					c_wxid: this.customMember.friends_open_id,
					f_wxid: this.clusterInfo.id,
					type: 'cluster'
				}
				this.$router.push({
					path: '/chat/chat',
					query:query
				})
			}
		},
		computed:{
			otherEvent(){
				return this.$store.state.otherEvent
			}
		},
		
		watch:{
			cluster(nVal){
				this.getDetail()
			},
			
			// 监听socket事件
			otherEvent(nVal){
				if(nVal.type === undefined){
					return
				}
				let _this = this
				switch(nVal.type){
					case 'C_AddMemberFromRoom':
						this.reloadById(nVal.clusterId)
						break
					case 'C_DelMemberFromRoom':
						this.reloadById(nVal.clusterId)
						break
					case 'update_wechatQr':
						setTimeout(function(){
							if(nVal.open_id == _this.clusterInfo.wechat_cluster_id){
								_this.getDetail()
							}
						},2000)
						break
					case 'C_GetRoomMembers':
						if(nVal.roomId == _this.clusterInfo.wechat_cluster_id){
							_this.getDetail()
						}
						break
				}
			}
		},
		mounted() {
			this.getDetail()
		}
	}
</script>

<style>
	.chat-cluster-info-box{
		position: relative;
		width: 100%;
		height: 100%;
		overflow: hidden;
	}
	.chat-cluster-info-box .chat-cluster-i-wrap{
		width: 100%;
		height: 100%;
		padding: 20px;
		box-sizing: border-box;
		overflow-x: hidden;
		overflow-y: auto;
		position: relative;
	}
	.chat-cluster-i-wrap .chat-cluster-i-basic{
		width: 100%;
		height: 320px;
		padding: 20px;
		box-sizing: border-box;
		background-color: #f3f3f3;
		display: flex;
		justify-content: flex-start;
		align-items: center;
		flex-wrap: nowrap;
		border-radius: 4px;
		box-shadow: 0 1px 5px 0 #cacaca;
		overflow: hidden;
	}
	.chat-cluster-i-basic .chat-cluster-ib-l{
		width: 200px;
		height: 260px;
		overflow: hidden;
		margin-right: 20px;
		background-color: #FFFFFF;
		padding: 10px;
		box-shadow: 0 0 5px 0 #cecece;
	}
	.chat-cluster-ib-l .chat-cluster-ibl-basic{
		width: 100%;
		height: 40px;
		overflow: hidden;
		display: flex;
		justify-content: flex-start;
		flex-wrap: nowrap;
	}
	.chat-cluster-ibl-basic .chat-cluster-ibl-avatar{
		width: 40px;
		height: 40px;
		overflow: hidden;
		margin-right: 10px;
	}
	.chat-cluster-ibl-avatar img{
		width: 100%;
		height: 100%;
		border-radius: 4px;
	}
	.chat-cluster-ibl-basic .chat-cluster-ibl-title{
		width: 0;
		height: 40px;
		line-height: 40px;
		flex-grow: 1;
	}
	.chat-cluster-ib-l .chat-cluster-ibl-code{
		width: 180px;
		height: 180px;
		padding: 10px;
		overflow: hidden;
	}
	.chat-cluster-ibl-code img{
		width: 100%;
		height: 100%;
		cursor: pointer;
	}
	.chat-cluster-ib-l .chat-cluster-ibl-time{
		height: 20px;
		line-height: 20px;
		overflow: hidden;
		font-size: 12px;
		color: #999999;
		text-align: center;
	}
	.chat-cluster-ibl-time-reload{
		color: #007DDB;
		cursor: pointer;
		font-weight: 600;
		user-select: none;
	}
	.chat-cluster-i-basic .chat-cluster-ib-r{
		width: 0;
		height: auto;
		flex-grow: 1;
	}
	.chat-cluster-ib-r .chat-cluster-ibr-info{
		width: 100%;
		margin-bottom: 15px;
	}
	.chat-cluster-ibr-info .chat-cluster-ibr-item{
		width: 100%;
		display: flex;
		justify-content: flex-start;
		margin-bottom: 10px;
		min-height: 30px;
		max-height: 60px;
		line-height: 30px;
	}
	.chat-cluster-ibr-item .chat-cluster-ibr-title{
		margin-right: 5px;
		width: 75px;
		text-align: center;
	}
	.chat-cluster-ibr-item .chat-cluster-ibr-text{
		width: 0;
		flex-grow: 1;
	}
	.chat-cluster-ibr-text input{
		width: 80%;
		height: 30px;
		padding: 0 5px;
		box-sizing: border-box;
		resize: none;
		border: 1px solid #e0e0e0;
		border-radius: 4px;
		font-size: 12px;
		display: block;
		color: #999999;
	}
	.chat-cluster-ibr-text textarea{
		width: 80%;
		height: 62px;
		padding: 5px 5px;
		box-sizing: border-box;
		resize: none;
		border: 1px solid #e0e0e0;
		border-radius: 4px;
		font-size: 12px;
		line-height: 16px;
		color: #999999;
	}
	.chat-cluster-ibr-text input:focus,.chat-cluster-ibr-text textarea:focus{
		border: 1px solid #42B983; 
	}
	.chat-cluster-ib-r .chat-cluster-ibr-tools{
		width: 100%;
		height: 30px;
		line-height: 30px;
		display: flex;
		justify-content: flex-start;
		color: #FFFFFF;
		padding-left: 75px;
		box-sizing: border-box;
	}
	.chat-cluster-ibr-tools > div{
		margin-right: 10px;
		padding: 0 10px;
		border-radius: 4px;
		cursor: pointer;
	}
	.chat-cluster-ibr-code{
		background-color: #13b9ff;
	}
	.chat-cluster-ibr-nickname{
		background-color: #e6c341;
	}
	.chat-cluster-ibr-remark{
		background-color: #e6c341;
	}
	.chat-cluster-ibr-sender{
		background-color: #009688;
	}
	.chat-cluster-ibr-stop{
		background-color: #ff5f2a;
	}
	.chat-cluster-ibr-uc{
		background-color: #13b9ff;
	}
	.chat-cluster-ibr-uf{
		background-color: #13b9ff;
	}
	.chat-cluster-i-wrap .chat-cluster-i-numbers{
		position: absolute;
		top: 360px;
		bottom: 20px;
		left: 20px;
		right: 20px;
		background-color: #f3f3f3;
		border-radius: 4px;
		box-shadow: 0 1px 5px 0 #cacaca;
		overflow: hidden;
	}
	.chat-cluster-i-numbers .chat-cluster-in-list{
		position: absolute;
		top: 20px;
		left: 20px;
		right: 20px;
		bottom: 20px;
		overflow: hidden;
	}
	.chat-cluster-in-list .chat-cluster-in-items-wrap{
		position: relative;
		width: 100%;
		height: 100%;
		overflow-x: hidden;
		overflow-y: auto;
	}
	.chat-cluster-in-items-wrap::-webkit-scrollbar{
		width: 6px;
		height: auto;
	}
	.chat-cluster-in-items-wrap::-webkit-scrollbar-track{
	  border-radius: 3px;
	  background:#e3e3e3;
	}
	.chat-cluster-in-items-wrap::-webkit-scrollbar-thumb{
		border-radius: 3px;
		-webkit-box-shadow: inset 0 0 5px rgba(0,0,0,0.2);
		background:#cbcbcb;
		cursor: pointer;
	}
	.chat-cluster-in-items-wrap .chat-cluster-in-items{
		width: 100%;
		height: auto;
		display: flex;
		justify-content: flex-start;
		flex-wrap: wrap;
	}
	.chat-cluster-in-items .chat-cluster-in-item{
		width: 76px;
		height: 106px;
		margin: 10px;
		overflow: hidden;
	}
	.chat-cluster-in-item img{
		width: 76px;
		height: 76px;
		border-radius: 4px;
	}
	.chat-cluster-in-item p{
		height: 30px;
		line-height: 30px;
		font-size: 12px;
		color: #999999;
		text-align: center;
	}
	.chat-cluster-in-item .chat-cluster-ini-optmem{
		display: block;
		width: 74px;
		height: 74px;
		line-height: 74px;
		text-align: center;
		font-size: 30px;
		border: 1px dashed #CCCCCC;
		border-radius: 4px;
		color: #999999;
		cursor: pointer;
		background-image: url(../../../assets/img/jiahao-8a-48.png);
		background-position: center;
		background-repeat: no-repeat;
		background-size: 30px auto;
	}
	.chat-cluster-in-item .chat-cluster-ini-optreduce{
		background-image: url(../../../assets/img/jianhao-8a-48.png);
	}
</style>
